import React from 'react';

class CardListNav extends React.PureComponent {
    onKeyDown = event => {
        this.props.onKeyDown(event);
    };
    render() {
        let childProps = {};
        childProps.onKeyDown = this.onKeyDown;
        return React.cloneElement(
            React.Children.only(this.props.children),
            childProps
        );
    }
}

export default CardListNav;
export { CardListNav };
